var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCritVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03572 16.0714C12.4737 16.0714 16.0714 12.4737 16.0714 8.03571C16.0714 12.4727 19.6675 16.0697 24.104 16.0714C19.6675 16.0731 16.0714 19.6702 16.0714 24.1072C16.0714 19.6692 12.4737 16.0714 8.03572 16.0714C3.59771 16.0714 3.27146e-07 19.6692 2.10751e-07 24.1072L0 32.1429L8.03572 32.1429C12.4737 32.1429 16.0714 28.5452 16.0714 24.1072C16.0714 28.5452 19.6692 32.1429 24.1072 32.1429L32.1429 32.1429L32.1429 24.1072C32.1429 19.6702 28.5469 16.0731 24.1103 16.0714C28.5469 16.0697 32.1429 12.4727 32.1429 8.03572L32.1429 -4.81828e-06L24.1072 -4.56738e-06C19.6692 -4.42882e-06 16.0714 3.59771 16.0714 8.03571C16.0714 3.59771 12.4737 -4.20416e-06 8.03572 -4.06559e-06L2.24802e-06 -7.62939e-06L1.33476e-06 8.03571C8.30381e-07 12.4737 3.59771 16.0714 8.03572 16.0714Z",
    fill: "#05C3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritVector);
export default __webpack_public_path__ + "static/media/CritVector.34b8f80ba2848455eeae7d4d355b209c.svg";
export { ForwardRef as ReactComponent };